import * as React from 'react'

import { useDispatch } from 'react-redux'
import { refInit } from '../../state/Firebase/operations'

const Init = () => {
  const dispatch = useDispatch()

  React.useEffect(() => {
    dispatch(refInit())
  }, [dispatch])

  return null
}

export default Init
